import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {toast } from "react-toastify";

function EditClient({ client, closeModal, onClientUpdated }) {
  const navigate = useNavigate();
  const [clientData, setClientData] = useState(client);

  useEffect(() => {
    setClientData(client); // Update when client prop changes
  }, [client]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/client/${client._id}`, clientData,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      toast.success("Client updated successfully!");
      if (onClientUpdated) onClientUpdated();
      closeModal();
    } catch (error) {
      console.error('Error updating client:', error);
      toast.error("Failed to update client!");
    }
  };

  return (
    <div className="max-h-[80vh] overflow-y-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Edit Client</h2>
      <form onSubmit={handleUpdate} className="space-y-4">
        {/* Basic Client Info */}
        <div>
          <label className="block text-sm font-medium mb-1">Client Name</label>
          <input
            type="text"
            name="clientName"
            value={clientData.clientName || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
            required
            className="w-full border rounded px-3 py-2"
            placeholder="Enter client name"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Company</label>
          <input
            type="text"
            name="company"
            value={clientData.company || ''}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Group</label>
          <input
            type="text"
            name="group"
            value={clientData.group || ''}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              name="Email"
              value={clientData.Email || ''}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Contact</label>
            <input
              type="tel"
              name="contact"
              value={clientData.contact || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              pattern="\d{10}"
              inputMode="numeric"
              maxLength={10}
              className="w-full border rounded px-3 py-2"
              placeholder="Enter 10-digit mobile number"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Alternate Contact</label>
            <input
              type="tel"
              name="contactalt"
              value={clientData.contactalt || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
              required
              pattern="\d{10}"
              inputMode="numeric"
              maxLength={10}
              className="w-full border rounded px-3 py-2"
              placeholder="Enter 10-digit mobile number"
            />
          </div>
        </div>

        {/* Address Information */}
        <div className="border rounded p-4 space-y-4 bg-gray-50">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Building</label>
              <input
                type="text"
                name="building"
                value={clientData.building || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Street</label>
              <input
                type="text"
                name="street"
                value={clientData.street || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">City</label>
              <input
                type="text"
                name="city"
                value={clientData.city || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">State</label>
              <input
                type="text"
                name="state"
                value={clientData.state || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">District</label>
            <textarea
              name="district"
              value={clientData.district || ''}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Pincode</label>
              <input
                type="number"
                name="pincode"
                value={clientData.pincode || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">field</label>
              <input
                type="text"
                name="field"
                value={clientData.field || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
      
            </div>
          </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">description</label>
                <textarea
                type="text"
                name="description"
                value={clientData.description || ''}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between mt-4">
          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Save Changes
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditClient;
